import type { ComponentType } from 'react';

import type { RegistryFieldsType } from '@rjsf/utils';
import { z } from 'zod';

import { TableEditorFieldWriter } from '@/components/forms/components/form/writer/fields/tableEditor/tableEditor.writer';
import { withInlineValidation } from '@/components/forms/wrappers/withInlineValidation';
import { FileUploadField } from './fileUpload/fileUpload.writer';

export const FormFieldSchema = z.enum(['FileUploadField', 'DataEditorWidget']);
export type FormFields = z.infer<typeof FormFieldSchema>;

const rawFields = {
  FileUploadField: withInlineValidation(FileUploadField as any),
  DataEditorWidget: TableEditorFieldWriter
} as const satisfies Record<FormFields, ComponentType<any>>;

export const fields = rawFields as unknown as RegistryFieldsType;
